import { useState } from "react";
import CommonPagination from "../../../common/components/pagination/CommonPagination";
import TabSelector from "../../../common/components/tab-selector/TabSelector";
import styles from "./LeadsPage.module.scss";
import NewLeads from "./components/new-leads/NewLeads";
import { AssessmentStatus } from "../../../model/leads/leads";
import ActiveLeads from "./components/ActiveLeads";
import { useGetLeadsQuery } from "../../../service/leads-service";
import CommonLoadingSpinner from "../../../common/components/loading-spinner/CommonLoadingSpinnerForPage";
import { useConfigLayout } from "../../../hooks/useConfigLayout";
const LeadsPage = () => {
	const [selectedTab, setSelectedTab] = useState(1);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(20);

	useConfigLayout({
						showCountrySelector: true,
						utility: null,
						showExportButton: false,
						showBreadCrumb: false,
						exportHandler: () => {},
					});

	const getStatusesForTab = (tabType: number): AssessmentStatus[] => {
		switch (tabType) {
			case 1:
				return [
					AssessmentStatus.ChosingProvider,
				];
			case 2:
				return [
					AssessmentStatus.SendingProductsThatFit,
					AssessmentStatus.CheckingDigitalLoadAssessment,
					AssessmentStatus.CarringOutPhysicalLoadAssessment,
					AssessmentStatus.ScheduledPhysicalLoadAssessment,
					AssessmentStatus.RescheduledPhysicalLoadAssessment,
					AssessmentStatus.OverduePhysicalLoadAssessment,
					AssessmentStatus.Pending,
				];
			case 3:
				return [
					AssessmentStatus.Passive,
					AssessmentStatus.NoProvider
				];
			case 4:
				return [
					AssessmentStatus.Final,
				];
			default:
				return [AssessmentStatus.ChosingProvider];
		}
	};

	const statuses = getStatusesForTab(selectedTab);

	const queryParams = {
		page: currentPage,
		pageSize: pageSize,
		statuses: statuses
	};

	// Fetch data using RTK Query
	const { data: leadsResponse, isLoading, isFetching } = useGetLeadsQuery(queryParams);

	const changeTab = (tabId: number) => {
		setSelectedTab(tabId);
		setCurrentPage(1);
	};

	const tabs = [
		{ id: 1, title: "New Leads", onClick: () => changeTab(1) },
		{ id: 2, title: "Active Leads", onClick: () => changeTab(2) },
		{ id: 3, title: "Dead Leads", onClick: () => changeTab(3) },
		{ id: 4, title: "Closed Leads", onClick: () => changeTab(4) },
	];

	const totalPages = leadsResponse?.totalPages ?? 1;
	const items = leadsResponse?.items ?? [];


	const renderTabContent = () => {
		switch (selectedTab) {
			case 1:
				return <NewLeads data={items} />;
			case 2:
				return <ActiveLeads data={items} />;
			case 3:
				return <ActiveLeads data={items} />;
			case 4:
				return <ActiveLeads data={items} />;
			default:
				return <NewLeads data={items} />;
		}
	};

	return (
		<div>
			<div className={styles.tabSelectorWrapper}>
				<div className={styles.tabContainer}>
					<TabSelector tabs={tabs} selectedTab={selectedTab} theme="yellow" />
				</div>
				<CommonLoadingSpinner loading={isLoading}>
				  {renderTabContent()}
				</CommonLoadingSpinner>
				<div className={styles.paginationContainer}>
					<CommonPagination
						currentPage={currentPage}
						isLoading={isFetching}
						numberOfPages={totalPages}
						onPageChange={(page: number) => {
							setCurrentPage(page);
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default LeadsPage;
